const profile = {
    name: 'Tên',
    avatar: 'Ảnh đại diện',
    givenName: 'Tên',
    familyName: 'Họ',
    middleName: 'Tên đệm',
    fullname: 'Họ và tên',
    nickname: 'Tên gọi khác',
    preferredUsername: 'Tên đăng nhập ưa thích',
    profile: 'Hồ sơ',
    website: 'Trang web',
    gender: 'Giới tính',
    birthdate: 'Ngày sinh',
    zoneinfo: 'Múi giờ',
    locale: 'Ngôn ngữ',
    address: {
        formatted: 'Địa chỉ',
        streetAddress: 'Địa chỉ đường',
        locality: 'Thành phố',
        region: 'Tỉnh/Thành',
        postalCode: 'Mã bưu điện',
        country: 'Quốc gia',
    },
    gender_options: {
        female: 'Nữ',
        male: 'Nam',
        prefer_not_to_say: 'Không muốn tiết lộ',
    },
    checkbox_value: {
        checked: 'Có',
        unchecked: 'Không',
    },
    avatar_upload: {
        upload: 'Tải lên',
        remove: 'Xóa',
        uploading: 'Đang tải lên...',
        hint: 'Kích thước đề xuất 1:1, tối đa {{limit}}.',
        error_file_type: 'Loại tệp phải là {{extensions}}.',
        error_file_size: 'Kích thước tệp không được vượt quá {{limit}}.',
        error_storage_not_configured: 'Không thể tải lên ảnh của bạn. Vui lòng thử lại sau.',
        error_upload: 'Tải ảnh lên thất bại. Vui lòng thử lại.',
        error_save: 'Lưu ảnh thất bại. Vui lòng thử lại.',
        crop_title: 'Cắt ảnh của bạn',
        zoom: 'Thu phóng',
        error_crop: 'Cắt ảnh thất bại. Vui lòng thử lại.',
    },
};
export default Object.freeze(profile);
